@if (currentRoles(); as currentRoles) {
  <div class="flex flex-col justify-between">
    <div class="flex flex-col gap-1 py-2">
      <div class="text-gray-11">
        @if (currentRoles.length !== 0) {
          @for (role of currentRoles; track $index) {
            <span>{{ role.name | titlecase }}</span>
            @if (currentRoles[currentRoles.length - 1] !== role) {
              <span>, </span>
            }
          }
        } @else {
          <div>Aucun rôle pour cet utilisateur</div>
        }
      </div>
    </div>
  </div>
}
